import React from "react";
import "../../styles/priceform.css";
import CheckBox from "../../components/CheckBox";


const PriceForm = () => {
  return (
    <div className="container price-form-container">
      <div className="form-details">
        <div className="input-div">
          <label htmlFor="name">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do?
          </label>
          <br />
          <br />
          <input type="text" placeholder="Enter your full name" />
        </div>
        <div className="input-div">
          <label htmlFor="name">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do?
          </label>
          <br />
          <br />
          <input type="text" placeholder="Enter your full name" />
        </div>
        <div className="input-div">
          <label htmlFor="name">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do?
          </label>
          <br />
          <br />
          <input type="text" placeholder="Enter your full name" />
        </div>

        <div className="input-div-range">
          <div className="show-range">1,200000</div>
          <input type="range" placeholder="Enter your full name" />
          <label htmlFor="name">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do?
          </label>
        </div>
        {/* Demographic */}
        <div className="demographic-container">
          <h2 className="demographic-heading">Demographics</h2>
          <div className="age-container">
            <div className="label-container">Age</div>
            <div className="options-container">
              <div className="checkbox-div">
                <CheckBox name={"age"}></CheckBox>
                <label htmlFor="age">15-23</label>
              </div>
              <div className="checkbox-div">
                <CheckBox name={"age"}></CheckBox>
                <label htmlFor="age">15-23</label>
              </div>
              <div className="checkbox-div">
                <CheckBox name={"age"}></CheckBox>
                <label htmlFor="age">15-23</label>
              </div>
              <div className="checkbox-div">
                <CheckBox name={"age"}></CheckBox>
                <label htmlFor="age">15-23</label>
              </div>
            </div>
          </div>
          {/* gender */}
          <div className="age-container">
            <div className="label-container">Gender</div>
            <div className="options-container">
              <div className="checkbox-div">
                <CheckBox name={"gender"}></CheckBox>
                <label htmlFor="age">Male</label>
              </div>
              <div className="checkbox-div">
                <CheckBox name={"gender"}></CheckBox>
                <label htmlFor="age">Female</label>
              </div>
              <div className="checkbox-div">
                <CheckBox name={"gender"}></CheckBox>
                <label htmlFor="age">Non-Binary</label>
              </div>
            </div>
          </div>
          {/* Geolocation */}
          <div className="age-container">
            <div className="label-container">Geolocation Criteria</div>
            <div className="options-geolocation">
              <div className="checkbox-div">
                <CheckBox name={"geo"}></CheckBox>
                <label htmlFor="geo">Country</label>
              </div>
              <div className="checkbox-div">
                <CheckBox name={"geo"}></CheckBox>
                <label htmlFor="age">Region/State</label>
              </div>
              <div className="checkbox-div">
                <CheckBox name={"geo"}></CheckBox>
                <label htmlFor="age">City</label>
              </div>
              <div className="checkbox-div">
                <CheckBox name={"geo"}></CheckBox>
                <label htmlFor="age">Radius</label>
              </div>
            </div>
          </div>
          {/* Behavour */}
          <div className="age-container">
            <div className="label-container">Behavior & Patterns</div>
            <div className="options-geolocation">
              <div className="checkbox-div">
                <CheckBox name={"behave"}></CheckBox>
                <label htmlFor="age">Country</label>
              </div>
              <div className="checkbox-div">
                <CheckBox name={"behave"}></CheckBox>
                <label htmlFor="age">Region/State</label>
              </div>
              <div className="checkbox-div">
                <CheckBox name={"behave"}></CheckBox>
                <label htmlFor="age">City</label>
              </div>
              <div className="checkbox-div">
                <CheckBox name={"behave"}></CheckBox>
                <label htmlFor="age">Radius</label>
              </div>
            </div>
          </div>
          {/* Basic */}
          <div className="age-container">
            <div className="label-container">Basic Profiling</div>
            <div className="options-geolocation">
              <div className="checkbox-div">
                <CheckBox name={"profile"}></CheckBox>
                <label htmlFor="age">Country</label>
              </div>
              <div className="checkbox-div">
                <CheckBox name={"profile"}></CheckBox>
                <label htmlFor="age">Region/State</label>
              </div>
              <div className="checkbox-div">
                <CheckBox name={"profile"}></CheckBox>
                <label htmlFor="age">City</label>
              </div>
              <div className="checkbox-div">
                <CheckBox name={"profile"}></CheckBox>
                <label htmlFor="age">Radius</label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="calculator">
        <div className="total-cost">
          <h2>Total Cost</h2>
          <div className="line-total-cost"></div>
          <div className="estimate">
            <p>Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet</p>
            <h1>15950 <span className="inr">INR</span></h1> 
            <p className="estimate-para">Total Estimated Cost</p>
            <button className="btn-primary inte-btn">Create Survey</button>
            <br />
            
            <div className="line-total-cost"></div>
          </div>
          <div className="custom-div">
            <h1>Custom Plan</h1>
            <p>Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet</p>
            <button className="btn-primary inte-btn">Contact Us</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PriceForm;
